import { __assign, __read, __spreadArray, __values } from "tslib";
import VariantItem from "FilterBar/Types/variant-item";
import format from "date-fns/format";
import fr from "date-fns/locale/fr";
import de from "date-fns/locale/de";
import { differenceInCalendarDays, differenceInCalendarMonths } from "date-fns";
import { DateHelper } from "helper";
var VariantsHelper = /** @class */ (function () {
    function VariantsHelper() {
        this.variantsMap = new Map();
        this.monthsSet = new Set();
    }
    VariantsHelper.prototype.isMonthLoaded = function (date) {
        return this.monthsSet.has(format(new Date(date), 'YYYY-MM'));
    };
    Object.defineProperty(VariantsHelper, "instance", {
        get: function () {
            if (!VariantsHelper._instance)
                VariantsHelper._instance = new VariantsHelper();
            return VariantsHelper._instance;
        },
        enumerable: false,
        configurable: true
    });
    VariantsHelper.prototype.formatDate = function (date) {
        if (/\/fr\//.test(location.href)) {
            return DateHelper.capitalize(format(new Date(date), 'ddd DD.MM.', { locale: fr }));
        }
        else {
            return format(new Date(date), 'dd. DD.MM.', { locale: de });
        }
    };
    VariantsHelper.prototype.flushMap = function () {
        this.variantsMap.clear();
    };
    VariantsHelper.prototype.generateCalendarDates = function (startDate, days, callback) {
        if (days === void 0) { days = 35; }
        if (callback === void 0) { callback = function (date, index) { return date; }; }
        return Array.from({ length: days }, function (_, i) {
            var date = new Date(startDate);
            date.setDate(date.getDate() + i);
            return callback(date, i);
        });
    };
    VariantsHelper.prototype.updateVariantsMap = function (products) {
        var _this = this;
        products.forEach(function (x) { return _this.variantsMap.set(x.travelPeriod.departureDate, new VariantItem(0, x.travelPeriod.departureDate, _this.formatDate(x.travelPeriod.departureDate), x.price.amountPerPerson, x.price.amountPerPerson.toLocaleString('de-DE'), false, true)); });
    };
    VariantsHelper.prototype.generateVariantItems = function (startDate, days) {
        var _this = this;
        var bestPrice = Infinity;
        return this.generateCalendarDates(startDate, days, function (date, i) {
            var variant = _this.variantsMap.get(format(date, 'YYYY-MM-DD'));
            if (variant && variant.price < bestPrice)
                bestPrice = variant.price;
            var currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            return __assign({ day: date.getDate(), id: format(date, 'YYYY-MM-DD'), date: _this.formatDate(date), available: false, outdated: date < currentDate }, variant);
        });
    };
    VariantsHelper.prototype.calculateHighlightedPrices = function (startDate, endDate) {
        var e_1, _a;
        startDate = new Date(startDate);
        var travelPeriodPriceHighlight = Infinity;
        var travelPeriodVariantHighlights = [];
        var diff = differenceInCalendarDays(endDate, startDate);
        for (var i = 0; i <= diff; i++) {
            var current = this.variantsMap.get(format(startDate, 'YYYY-MM-DD'));
            if (current && current.price < travelPeriodPriceHighlight) {
                travelPeriodPriceHighlight = current.price;
                travelPeriodVariantHighlights = [current];
            }
            else if (current && current.price === travelPeriodPriceHighlight) {
                travelPeriodVariantHighlights.push(current);
            }
            startDate.setDate(startDate.getDate() + 1);
        }
        travelPeriodVariantHighlights.forEach(function (variant) { return variant.travelPeriodPriceHighlight = true; });
        var monthlyBestPriceMap = new Map();
        try {
            for (var _b = __values(this.variantsMap), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], variant = _d[1];
                var monthKey = format(key, 'YYYY-MM');
                if (!this.monthsSet.has(monthKey))
                    continue;
                if (!monthlyBestPriceMap.has(monthKey) || variant.price < monthlyBestPriceMap.get(monthKey)[0].price)
                    monthlyBestPriceMap.set(monthKey, [variant]);
                else if (monthlyBestPriceMap.has(monthKey) && variant.price === monthlyBestPriceMap.get(monthKey)[0].price)
                    monthlyBestPriceMap.get(monthKey).push(variant);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        monthlyBestPriceMap.forEach(function (month) { return month.forEach(function (variant) { return variant.bestPrice = true; }); });
    };
    VariantsHelper.prototype.generateMonthsSet = function (fromDate, toDate) {
        var iterator = new Date(fromDate.getFullYear(), fromDate.getMonth());
        var months = new Set();
        var diff = differenceInCalendarMonths(toDate, fromDate);
        for (var i = 0; i <= diff; i++) {
            months.add(format(iterator, 'YYYY-MM'));
            iterator.setMonth(iterator.getMonth() + 1);
        }
        return months;
    };
    VariantsHelper.prototype.cropDatesToFullMonth = function (startDate, endDate) {
        startDate = new Date(startDate);
        endDate = new Date(endDate ? endDate : startDate);
        startDate.setDate(1);
        endDate.setMonth(endDate.getMonth() + 1);
        endDate.setDate(0);
        return {
            startDate: startDate,
            endDate: endDate,
            months: this.generateMonthsSet(startDate, endDate)
        };
    };
    VariantsHelper.prototype.getFirstMondayForCalendarDate = function (date) {
        var firstMonday = new Date(date.getFullYear(), date.getMonth());
        firstMonday.setDate(firstMonday.getDate() - ((firstMonday.getDay() + 6) % 7));
        return firstMonday;
    };
    VariantsHelper.prototype.getLastSundayForCalendarDate = function (date) {
        var lastSunday = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        var offset = 6 - ((lastSunday.getDay() + 6) % 7);
        lastSunday.setDate(lastSunday.getDate() + offset);
        return lastSunday;
    };
    VariantsHelper.prototype.insertDate = function (startDate, endDate, insertDate) {
        if (insertDate === void 0)
            return { startDate: startDate, endDate: endDate };
        var minStartDate = insertDate != void 0 ? new Date(Math.min(startDate.getTime(), insertDate.getTime())) : startDate;
        var maxEndDate = insertDate != void 0 ? new Date(Math.max(endDate.getTime(), insertDate.getTime())) : endDate;
        return {
            startDate: minStartDate,
            endDate: maxEndDate
        };
    };
    VariantsHelper.prototype.getVariantsRequestTimespan = function (startDate, offset, endDate, shiftedDate) {
        var timespan = this.insertDate(new Date(startDate), new Date(endDate || startDate), shiftedDate && new Date(shiftedDate));
        var croppedTimespan = this.cropDatesToFullMonth(timespan.startDate, timespan.endDate);
        var shiftedEndDate = this.getLastSundayForCalendarDate(croppedTimespan.endDate);
        shiftedEndDate.setDate(shiftedEndDate.getDate() + offset);
        this.monthsSet = new Set(__spreadArray(__spreadArray([], __read(croppedTimespan.months), false), __read(this.monthsSet), false));
        return {
            startDate: this.getFirstMondayForCalendarDate(croppedTimespan.startDate),
            endDate: shiftedEndDate,
        };
    };
    return VariantsHelper;
}());
export { VariantsHelper };
